import Swal from 'sweetalert2'

document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('htmx:confirm', function (e) {
        const firstChild = e.target

        if (!firstChild.hasAttribute('s-confirm')) return
        e.preventDefault()
        const html =
            document.querySelector('.js-acceptDialogText')?.innerHTML || ''
        const inputLabel =
            document.querySelector('.js-acceptCheckboxText')?.innerHTML || ''
        Swal.fire({
            title: `${e.detail.question}`,
            //text: firstChild.getAttribute('data-text') ?? null,
            html,
            confirmButtonText:
                firstChild.getAttribute('data-confirm-label') ?? null,
            cancelButtonText:
                firstChild.getAttribute('data-cancel-label') ?? null,
            showCancelButton: true,
            customClass: {
                popup: '!bg-white !p-8 lg:!p-16 !flex flex-col !max-w-3xl !w-[90vw] !rounded-none',
                title: '!trim-heading !font-(family-name:--font-heading) !mb-5 !text-xl2 !text-black !font-(--heading-font-weight) !text-(--heading-color) !text-start !p-0',
                cancelButton:
                    '!p-8 !border-black !bg-white ease-custom !transition-colors !m-0 !duration-500 hover:!bg-black hover:!text-white !text-black !trim-body !rounded-none !border  m-0',
                confirmButton:
                    '!p-8 !border-primary !bg-primary !ease-custom !transition-colors !m-0 !duration-500 !text-black hover:!bg-black hover:!border-black hover:!text-white !trim-body !rounded-none !border  m-0',
                htmlContainer:
                    '!text-base !text-black !p-0 prose prose-custom !text-start',
                actions: '!mt-10 !flex !justify-start !gap-4 !m-0'
            },
            input: 'checkbox',
            inputValue: 0,
            inputPlaceholder: inputLabel,
            inputValidator: (result) => {
                if (
                    document.querySelector('html').getAttribute('lang') == 'nl'
                ) {
                    return !result && 'Bevestiging van bevoegdheid is vereist.'
                } else {
                    return (
                        !result && 'Confirmation of authorisation is required.'
                    )
                }
            }
        }).then(function (result) {
            if (result.isConfirmed) {
                e.detail.issueRequest(true)
            }
        })
    })
})
